import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { Router } from '@angular/router';
import { AuthentService, AuthenticationRole } from 'src/app/Services/authent.service';
import { FormularService } from 'src/app/Services/formular.service';
import { ErrorHandlingService } from 'src/app/Services/errorHandling.service';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  resourceDefinition;
  showRequestMenu = false;
  showStatisticMenu = false;
  showAdminMenu = false;
  User;
  contractExpirationDate;
  authRole = AuthenticationRole;
  isCompanyLocked: boolean;

  constructor(
    private shareData: SharingDataService,
    private router: Router,
    public authService: AuthentService,
    private formularService: FormularService,
    private errorHandlingService: ErrorHandlingService,
    private translateResourceDefinition: TranslateResourceDefinitionPipe,
  ) { }


  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    this.shareData.currentUser.subscribe(data => {
      if(data != null){
        this.User = data;
        this.getCurrentUserContract();
      }
    });
  }


  getCurrentUserContract(){
    var urls = [
      `admin/MS_CONTRACT?$filter=ID eq ${this.User.CONTRACT}`,
      `admin/MS_COMPANY?$filter=MID eq ${this.User.COMPANY_MID}`
    ]

    this.formularService.getData(urls, (data) => {
      const contract = data[0][0];
      const company = data[1][0];
      this.contractExpirationDate = new Date(contract.CONTRACT_EXPIRATION_DT);
      this.isCompanyLocked = company.UNUSED === 1 ? true : false;
      if(this.authService.currentUser().ROLE == this.authRole.ExternalAdmin || this.authService.currentUser().ROLE == this.authRole.ExternalUser || this.authService.currentUser().ROLE == this.authRole.Public){
        this.externalNewRequest(true);
      }
    })
  }


  route(route: string) {
    this.router.navigate([route]);
    if (route === 'newRequest' && this.router.url === '/newRequest') {
      location.reload();
    }
  }

  externalNewRequest(onInit: boolean){
    const actualDate = new Date();
    if(this.contractExpirationDate < actualDate || this.isCompanyLocked){
      if(this.contractExpirationDate < actualDate && !onInit){
        this.errorHandlingService.showError(this.translateResourceDefinition.transform('isExpiredEx', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common"), undefined);
      }
      if(this.isCompanyLocked  && !onInit){
        this.errorHandlingService.showError(this.translateResourceDefinition.transform('isCompanyLockedEx', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common"), undefined);
      }
      if (this.router.url === '/newRequest') {
        this.router.navigate([""]);
      }
    } else {
      if (this.router.url === '/newRequest' && !onInit) {
        location.reload();
      } else if (!onInit){
        this.router.navigate(["newRequest"]);
      }
    }
  }


  toggleRequestMenu() {
    this.showRequestMenu = !this.showRequestMenu;
  }


  toggleStatisticMenu() {
    this.showStatisticMenu = !this.showStatisticMenu;
  }


  toggleAdminMenu() {
    this.showAdminMenu = !this.showAdminMenu;
  }
}
